import React, { Component } from 'react'
import "./policyMatching.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiPolicyList , getApiUserInfos , setCompany , checkCompany } from "../../axios/api"
import { message } from 'antd'
import { get, set } from '../../axios/localstorage'


export default class policyMatching extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        name:"",

        showMore:false,
        show:false,
        showCompany:false,
    }

    componentWillMount(){
        window.scroll(0,0);
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();

        this.checkCompany();

        getApiUserInfos({token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    name:data.name,
                    // time:data.start_date
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    checkCompany=()=>{

        let param = {
            token:get('token')
        }

        checkCompany(param)
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    showCompany:false
                })
            }else{
                this.setState({
                    showCompany:true
                })
            }
        }).catch( err =>{
            console.error(err);
        })

    }

    setCompany=()=>{

        let param = {
            token:get('token'),
            company:this.state.company
        }

        setCompany(param)
        .then( req =>{
            if(req.data.code === 1){
                message.success("绑定成功");
                this.setState({
                    showCompany:false
                })
            }else{
                message.info(req.data.msg);
                this.setState({
                    showCompany:false
                })
            }
        }).catch( err =>{
            console.error(err);
        })

    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }



    getList=()=>{
        let param = {
            keywords:this.state.key,
            page:this.state.page,
        }

        getApiPolicyList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.list,
                    total:data.total
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='policyMatching'>
                <Header type={2} />
                <div className='htext'>
                    <div className='hname'>
                        <p>当前位置：</p>
                        <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                        <img alt="" src="/www/assets/imgs/xiaji.png" />
                        <p>政策匹配</p>
                    </div>
                </div>
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            

                            <div className='hbox'>
                                <div className='name'>
                                    <div></div>
                                    <p>填写资料</p>
                                </div>
                                {/* <div className='hitem'>
                                    <h2>公司名称<span>*</span></h2>
                                    <div className='hipt'>
                                    <input type="text" disabled placeholder='' value={this.state.name} onChange={(ev)=>{this.setState({name:ev.target.value})}} />
                                    </div>
                                </div> */}

                                <div className='cen'>
                                    <div className='hdiv'>
                                        <div className='ht'>公司名称</div>
                                        <div className='hipt'>
                                            <input type="text" disabled placeholder='请选择您管理的企业进行匹配' value={this.state.name} onChange={(ev)=>{this.setState({name:ev.target.value})}} />
                                            <button onClick={()=>{this.setState({show:true})}}>添加企业</button>
                                        </div>
                                    </div>
                                </div>

                                <div className='send'>
                                    <button onClick={()=>{

                                        if(!this.state.name){
                                            message.info('请先输入公司名称')

                                            return false;
                                        }

                                        set('key',this.state.name);
                                        
                                        this.gotoPage('/policyMatchingList')
                                        
                                        }}>立即匹配</button>
                                </div>
                                {/* <div className='hitem'>
                                    <h2>注册地<span>*</span></h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>注册时间</h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div>
                                <div className='name'>
                                    <div></div>
                                    <p>行业属性</p>
                                </div>
                                <div className='hitem'>
                                    <h2>是否被认定为高新技术企业：</h2>
                                    <div className='single'>
                                        <div className='sin chosen'>
                                            <div></div>
                                        </div>
                                        <p>高新技术企业</p>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>高新认定时间</h2>
                                    <div className='hipt'>
                                        <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                    </div>
                                </div>
                                <div className='hmul'>
                                    <h2>企业所属产业类别（可多选）<span>*</span></h2>
                                    <div className='hmbox'>
                                        <div className='hmi'>
                                            <div className='chosen'>
                                                <span></span>
                                            </div>
                                            <p>电子信息</p>
                                        </div>
                                        <div className='hmi'>
                                            <div className='chosen'>
                                                <span></span>
                                            </div>
                                            <p>5G/移动通信</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>物联网</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>人工智能</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>软件</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>集成电路</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>互联网</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>大数据</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>电子商务</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>云计算</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>区块链</p>
                                        </div>
                                        <div className='hmi'>
                                            <div>
                                                <span></span>
                                            </div>
                                            <p>生态修复</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='name'>
                                    <div></div>
                                    <p>科研实力</p>
                                </div>

                                <div className='hitem'>
                                    <h2>企业人数：</h2>
                                    <div className='hipt'>
                                    </div>
                                </div>

                                <div className='hitem'>
                                    <h2>整体学历水平：</h2>
                                    <div className='single'>
                                        <div className='sin chosen'>
                                            <div></div>
                                        </div>
                                        <p>较高</p>
                                        <div className='sin'>
                                            <div></div>
                                        </div>
                                        <p>一般</p>
                                        <div className='sin'>
                                            <div></div>
                                        </div>
                                        <p>偏低</p>
                                    </div>
                                </div>

                                <div className='hitem'>
                                    <h2>上年度主营业务收入：</h2>
                                    <div className='hipt'>
                                    </div>
                                </div>

                                <div className='hitem'>
                                    <h2>上年度是否有贷款或未来有计划贷款<span>*</span></h2>
                                    <div className='single'>
                                        <div className='sin chosen'>
                                            <div></div>
                                        </div>
                                        <p>是</p>
                                        <div className='sin'>
                                            <div></div>
                                        </div>
                                        <p>否</p>
                                    </div>
                                </div>

                                <div className='name'>
                                    <div></div>
                                    <p>其他优势</p>
                                </div>

                                <div className='hitem'>
                                    <h2>上年度设备和软件投入：</h2>
                                    <div className='hipt'>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>知识产权数量（项）：</h2>
                                    <div className='hipt'>
                                    </div>
                                </div>
                                <div className='hitem'>
                                    <h2>是否获得技术中心、实验室等称号：</h2>
                                    <div className='hipts'>
                                        <div className='hip1'>
                                            <p>区级</p>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                        </div>
                                        <div className='hip1 hw2'>
                                            <p>技术中心</p>
                                            <img className='hicon' alt="" src="/www/assets/imgs/xiala-neirong.png" />
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            
                        </div>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.show}>
                    <div className='abox'>
                        <img className='aclose' onClick={()=>{this.setState({show:false})}} alt="" src="/www/assets/imgs/chacha.png" />
                        <h1>添加企业</h1>
                        <div className='aitem'>
                            <h2><span>*</span> 公司名称</h2>
                            <div className='aipt'>
                                <input type="text" placeholder='请输入企业名称' value={this.state.company} onChange={(ev)=>{this.setState({company:ev.target.value})}} />
                            </div>
                        </div>
                        <div className='amsg'>
                        * 提示 ：还可添加{this.state.showCompany? 1 : 0}个企业
                        </div>
                        <div className='acen'>
                        <button className='abtn' onClick={()=>{this.setCompany()}}>确认添加</button>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
